// extracted by mini-css-extract-plugin
module.exports = {"phoneLink":"SupportPhoneLink_phoneLink__aPzgd"};